import Vue from 'vue'
import VueRouter from 'vue-router'
import { EventBus } from '@/helpers/eventBus'
// import { acquireToken } from '@/services/AuthService'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      requiresAuth: true,
      title: 'Home',
      description: 'Awesome Description'
    },
    props: true // Pass route params as props
  },
  {
    path: '/connect',
    name: 'Connect',
    component: () => import('../views/Connect.vue'),
    meta: {
      requiresAuth: true,
      title: 'Connect',
      description: 'Awesome Description'
    },
    props: route => ({ source: route.query.source, target: route.query.target }) // Pass both name and id as props
  },
  {
    path: '/integration/:name',
    name: 'Integration',
    component: () => import('../components/FeatureDetailsTab.vue'),
    meta: {
      requiresAuth: true,
      title: 'Integration',
      description: 'Showcases integrated features'
    },
    props: route => ({ name: route.params.name, id: route.query.id }) // Pass both name and id as props
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      requiresAuth: true,
      title: 'About',
      description: 'About us'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'),
    meta: {
      requiresAuth: true,
      title: 'Settings',
      description: 'User settings'
    }
  },
  {
    path: '/integration-request/:name',
    name: 'Integration Request',
    meta: {
      requiresAuth: true,
      title: 'Integration Request',
      description: 'Showcases integrated features'
    },
    component: () => import('../components/IntegrationRequestForm.vue'),
    props: route => ({ name: route.params.name, id: route.query.id }) // Pass both name and id as props
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      requiresAuth: true,
      title: 'Not found',
      description: 'Page not found'
    }
  },
  {
    path: '/metrics',
    name: 'metrics',
    component: () => import('../views/Metrics.vue'),
    meta: {
      requiresAuth: true,
      title: 'Metrics',
      description: 'Integration Metrics page'
    }
  },
  {
    path: '/migrations',
    name: 'Migratiions',
    component: () => import('../views/Migrations.vue'),
    meta: {
      requiresAuth: true,
      title: 'Migrations',
      description: 'Explore migrations from ALM to JIRA'
    }
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = Vue.prototype.$userInfo.accessToken
  if (token) {
    next()
  } else {
    EventBus.$emit('session-expired')
    // if (to?.query?.authRedirect) {
    //   EventBus.$emit('session-expired')
    //   next()
    //   return
    // }
    // console.log('Redirecting to login page')
    // router.push('/?authRedirect=true')
  }
})

export default router
